import styled from '@emotion/styled'
import { getFormValues, InjectedFormProps, reduxForm } from 'redux-form'
import {
  DatePickerField,
  InputField,
  SelectField,
  SelectWithSearchField,
  UploadfileField,
} from '../../components/common/fields'
import Card from '../../components/common/Card'
import Text from '../../components/common/Text'
import { mobile, mobileVerySmall } from '../../utils/responsive-helper'
import moment from 'moment'
import FooterContent from '../../components/FooterContent'
import Button from '../../components/common/Button'
import { ComponentType, useEffect, useMemo, useState } from 'react'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { EClaimInf, EClaimInfoWithConcentDate, EClaimInfoWithoutConcentDate, setClaimInfo } from '../../redux-store/e-claim-reducer'
import { useHistory } from 'react-router'
import * as paths from '../../constant/path'
import Input, { InputLabel } from '../../components/common/Input'
import color from '../../constant/colors'
import { useGetUser, useGetUserCoin } from '../../services/user/user-query'
import {
  useGetRelativeOption,
  useUploadFile,
  // useUploadReceiptImage,
} from '../../services/e-claim/e-claim-query'
import { UserClaimDocumentList, FileType } from '../../services/e-claim/e-claim-types'
import { Moment } from 'moment'
import Modal from '../../components/common/Modal'
import { useVisibility } from '../../utils/custom-hook'
import { convertBase64ToFile, getToken, numberWithCommas, useRelativeTypeName } from '../../utils/helper'
import { Divider, Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { CreateRelative } from '../Relative/component'
import { useTranslation } from 'react-i18next'
import OutlineButton from '../../components/common/OutlineButton'
import Image from '../../components/common/Image'
import config from '../../config'
import { HepatitisInfoWithConcentDate, HepatitisInfoWithoutConcentDate } from '../../redux-store/hepatitis-reducer'
import axios from 'axios'
import _ from 'lodash'
import { HepatitisFormParams, HepatitisHistoryItem, HepatitisItem } from '../../services/hepatitis/hepatitis-types'
import { setHepatitisInfo } from '../../redux-store/hepatitis-reducer'
import { useCreateHepatitisClaim } from '../../services/hepatitis/hepatitis-query'

const ClaimFormContainer = styled(Card)`
  padding: 16px;
  .layout-upload {
    ${mobile} {
      width: 100%;
    }
    ${mobileVerySmall} {
      width: 100%;
    }
  }
  ${mobile} {
    padding: 16px;
  }
  ${mobileVerySmall} {
    padding: 16px;
  }
`

const Spacer = styled.div`
  width: 20px;
  height: 20px;

  ${mobile} {
    display: none;
  }
`

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  column-gap: 16px;

  ${mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`

const FileUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;

  ${mobile} {
    flex-direction: column;
  }
`

const CustomEditableFooter = styled(FooterContent)`
  height: 80;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 18px;
  padding-bottom: 18px;

  ${mobile} {
    justify-content: center;
  }
`

const CustomUnEditableFooter = styled(FooterContent)`
  height: 80;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 18px;
  padding-bottom: 18px;
  column-gap: 16px;
  
  ${mobile} {
    flex-direction: column;
    justify-content: center;
  }
`

const SumPointContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;

  ${mobile} {
    margin-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
  }
`

const BackToEditButton = styled(Button)`
  width: 267px;
`
const SubmitButton = styled(Button)`
  width: 267px;
`
const TextModal = styled(Text)`
  text-align: center;
`

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  /* border: 1px solid; */
  margin-bottom: 8px;
  padding-bottom: 0;

  ${mobile} {
    width: 100%;
  }
`

const RelativeField = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  column-gap: 8px;
`

const CreateRelativeButton = styled(Button)`
  width: fit-content;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const ECLAIM_FORM_NAME = 'HEPATITIS_FORM'
type HepatitisItemType = HepatitisItem & HepatitisHistoryItem
type HepatitisParam = {
  hepatitisItem?: Partial<HepatitisItemType>
  editable?: boolean
  hepatitisFormValue?: HepatitisInfoWithConcentDate & HepatitisInfoWithoutConcentDate
  isPreview?: boolean
  allpayStatus?: boolean
  isHistory?: boolean
  hepatitisId?: number
  isCreateNew?: boolean
}
const required = (value: string) => (value ? undefined : 'error.required')
const requiredDate = (value: Moment) => {
  const x = moment(value).isValid() ? undefined : 'error.required'
  return x
}
const EClaimForm: ComponentType<
  HepatitisParam & InjectedFormProps<HepatitisFormParams, HepatitisParam, string>
> = (props) => {
  const dispatch = useDispatch()
  const {
    handleSubmit,
    invalid,
    hepatitisItem,
    editable = true,
    hepatitisFormValue,
    isPreview = false,
    allpayStatus,
    isHistory = false,
    hepatitisId,
    initialize,
    isCreateNew
  } = props

  const formValuesSelector = getFormValues(ECLAIM_FORM_NAME)
  const formValues = useSelector<any, HepatitisFormParams>(
    (state) => formValuesSelector(state) as HepatitisFormParams,
  )
  const { t, i18n } = useTranslation()
  const [visible, modalAction] = useVisibility()
  const [messageClaimCheck, setMessageClaimCheck] = useState('')
  const [visibleError, modalActionError] = useVisibility()
  const [errorMessage, setErrorMessage] = useState('')
  const [errorClaimMessage, setErrorClaimMessage] = useState('')
  const [isClaimCheck, setIsClaimCheck] = useState(false)
  const [claimAmountCheck, setClaimAmountCheck] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const { data: user } = useGetUser()
  const { firstName, lastName, userId } = user || {}

  const fullname = `${firstName} ${lastName}`
  const history = useHistory()
  const { data: userCoin = 0 } = useGetUserCoin()
  const { data: relativesOptions, refetch: refetchRelative } = useGetRelativeOption(hepatitisId)
  const { mutate: createHepatitisClaim, isLoading: isSubmitting } = useCreateHepatitisClaim()
  const { mutateAsync: uploadFile, isLoading: isUploading } = useUploadFile()
  // const { mutateAsync: uploadReceiptImage, isLoading: isUploadingReceipt, isError: isErrorUplaodReceiptImage } = useUploadReceiptImage()

  useEffect(() => {
    if (isCreateNew) {
      initialize({
        amountReceipt: hepatitisFormValue?.amountReceipt ? hepatitisFormValue?.amountReceipt : undefined,
        amountClaim: hepatitisFormValue?.amountClaim ? hepatitisFormValue?.amountClaim : undefined,
        receiptFile: hepatitisFormValue?.receiptFile ? hepatitisFormValue?.receiptFile : '',
        optionalFileUrl: hepatitisFormValue?.optionalFileUrl ? hepatitisFormValue?.optionalFileUrl : '',
        birthCertificate: hepatitisFormValue?.birthCertificate ? hepatitisFormValue?.birthCertificate : '',
        otherDocument: hepatitisFormValue?.otherDocument ? hepatitisFormValue?.otherDocument : '',
        relativeTypeId: hepatitisFormValue?.relativeTypeId ? hepatitisFormValue?.relativeTypeId : '0',
        receiptDate: hepatitisFormValue?.receiptDate ? hepatitisFormValue?.receiptDate : undefined,
        receiptNo: hepatitisFormValue?.receiptNo ? hepatitisFormValue?.receiptNo : '',
        // remark: hepatitisFormValue?.remark ? hepatitisFormValue?.remark : '',
      })
    } else {
      initialize({
        amountReceipt: formValues?.amountReceipt ? formValues?.amountReceipt : undefined,
        amountClaim: formValues?.amountClaim ? formValues?.amountClaim : undefined,
        receiptFile: formValues?.receiptFile ? formValues?.receiptFile : undefined,
        optionalFileUrl: formValues?.optionalFileUrl ? formValues?.optionalFileUrl : undefined,
        birthCertificate: formValues?.birthCertificate ? formValues?.birthCertificate : '',
        otherDocument: formValues?.otherDocument ? formValues?.otherDocument : '',
        relativeTypeId: formValues?.relativeTypeId ? formValues?.relativeTypeId : '0',
        receiptDate: formValues?.receiptDate ? formValues?.receiptDate : undefined,
        receiptNo: formValues?.receiptNo ? formValues?.receiptNo : '',
        // remark: formValues?.remark ? formValues?.remark : '',
      })
    }
  }, [])

  const onSubmit = useCallback(
    (form: HepatitisFormParams) => {

      dispatch(
        setHepatitisInfo({
          id: hepatitisItem?.id,
          name: form.name,
          amountReceipt: form.amountReceipt,
          amountClaim: claimAmountCheck,
          receiptFile: form.receiptFile,
          optionalFileUrl: form.optionalFileUrl,
          birthCertificate: form.birthCertificate,
          otherDocument: form.otherDocument,
          relativeTypeId: form.relativeTypeId,
          receiptDate: form.receiptDate,
          claimName: form.claimName,
          consentDate: hepatitisFormValue?.consentDate,
          receiptNo: form.receiptNo,
          // remark: form.remark,
        }),
      )
      if (editable === true) {
        history.push(paths.hepatitisSummary({ routeParam: { hepatitisId: hepatitisItem?.id || 0 } }))
      }
    },
    [dispatch, hepatitisItem?.id, editable, history, claimAmountCheck, hepatitisFormValue?.consentDate],
  )

  const getImageUploadUrl = useCallback(async (image, documentTypeId) => {
    try {
      const imageFile = await convertBase64ToFile(image || '')
      const imageFileUrl = await uploadFile({ files: imageFile, documentTypeId })

      return imageFileUrl[0].name
    } catch (error) {
      console.log("error", error)

      return ''
    }
  }, [uploadFile])

  const onSubmitApplication = useCallback(async () => {
    setIsLoading(true)
    const documentTypeIdForReceipt = hepatitisItem?.claimDocumentTypes?.find((item) => item.documentType.name === FileType.ReceiptFile)?.documentType.id
    const documentTypeIdForOptionalFile = hepatitisItem?.claimDocumentTypes?.find((item) => item.documentType.name === FileType.OptionalFileUrl)?.documentType.id
    const documentTypeIdForBirthCertificate = hepatitisItem?.claimDocumentTypes?.find((item) => item.documentType.name === FileType.BirthCertificate)?.documentType.id
    const documentTypeIdForOtherDocument = hepatitisItem?.claimDocumentTypes?.find((item) => item.documentType.name === FileType.OtherDocument)?.documentType.id

    let receiptImageURL = undefined
    let optionalFileUrl = undefined
    let birthCertificate = undefined
    let otherDocument = undefined

    if (hepatitisFormValue?.receiptFile && hepatitisFormValue?.receiptFile.split('/')[0].split(':')[0] === 'data') {
      //uploadfile
      receiptImageURL = await getImageUploadUrl(hepatitisFormValue?.receiptFile || '', documentTypeIdForReceipt)
    } else {
      receiptImageURL = hepatitisFormValue?.receiptFile
    }

    if (hepatitisFormValue?.optionalFileUrl && hepatitisFormValue?.optionalFileUrl.split('/')[0].split(':')[0] === 'data') {
      //uploadfile
      optionalFileUrl = await getImageUploadUrl(hepatitisFormValue?.optionalFileUrl || '', documentTypeIdForOptionalFile)
    } else {
      optionalFileUrl = hepatitisFormValue?.optionalFileUrl
    }

    if (hepatitisFormValue?.birthCertificate && hepatitisFormValue?.birthCertificate.split('/')[0].split(':')[0] === 'data') {
      birthCertificate = await getImageUploadUrl(hepatitisFormValue?.birthCertificate || '', documentTypeIdForBirthCertificate)
    } else {
      birthCertificate = hepatitisFormValue?.birthCertificate
    }

    if (hepatitisFormValue?.otherDocument && hepatitisFormValue?.otherDocument.split('/')[0].split(':')[0] === 'data') {
      otherDocument = await getImageUploadUrl(hepatitisFormValue?.otherDocument || '', documentTypeIdForOtherDocument)
    } else {
      otherDocument = hepatitisFormValue?.otherDocument
    }

    const userClaimDocumentList: UserClaimDocumentList[] = []
    if (receiptImageURL) {
      userClaimDocumentList.push({
        documentTypeId: documentTypeIdForReceipt || 0,
        documentPath: receiptImageURL,
      })
    }
    if (optionalFileUrl) {
      userClaimDocumentList.push({
        documentTypeId: documentTypeIdForOptionalFile || 0,
        documentPath: optionalFileUrl,
      })
    }
    if (birthCertificate) {
      userClaimDocumentList.push({
        documentTypeId: documentTypeIdForBirthCertificate || 0,
        documentPath: birthCertificate,
      })
    }
    if (otherDocument) {
      userClaimDocumentList.push({
        documentTypeId: documentTypeIdForOtherDocument || 0,
        documentPath: otherDocument,
      })
    }

    createHepatitisClaim(
      {
        claimId: hepatitisItem?.id || 0,
        receiptAmount: hepatitisFormValue?.amountReceipt!,
        relativeId: hepatitisFormValue?.relativeTypeId === '0' ? 0 : Number(hepatitisFormValue?.relativeTypeId),
        receiptDate: dayjs(hepatitisFormValue?.receiptDate).toISOString() || '',
        consentDate: hepatitisFormValue?.consentDate || null,
        consentBy: userId || 0,
        userClaimDocumentList: userClaimDocumentList,
        receiptNo: hepatitisFormValue?.receiptNo || '',
        // remark: hepatitisFormValue?.remark || '',
      },
      {
        onSuccess: (props) => {
          setIsLoading(false)
          history.push(
            paths.hepatitisCompleted({
              routeParam: { hepatitisId: hepatitisItem?.id || 0 },
              queryParam: {
                userClaimId: props?.id || 0,
              },
            }),
          )
        },
        onError: (error) => {
          setIsLoading(false)
          setErrorMessage(error.message)
          modalActionError.show()
        },
      },
    )
  }, [
    getImageUploadUrl,
    createHepatitisClaim,
    hepatitisItem?.id,
    hepatitisItem?.claimDocumentTypes,
    hepatitisFormValue?.amountReceipt,
    hepatitisFormValue?.relativeTypeId,
    hepatitisFormValue?.receiptDate,
    hepatitisFormValue?.receiptFile,
    hepatitisFormValue?.optionalFileUrl,
    hepatitisFormValue?.consentDate,
    hepatitisFormValue?.receiptNo,
    hepatitisFormValue?.birthCertificate,
    hepatitisFormValue?.otherDocument,
    // hepatitisFormValue?.remark,
    history,
    modalActionError,
    userId
  ])

  const onBackToEdit = useCallback(() => {
    history.push(paths.hepatitisDetail({ routeParam: { hepatitisId: hepatitisItem?.id || 0 } }))
  }, [hepatitisItem?.id, history])

  const onCheckCoin = useCallback(async () => {
    if (!formValues?.amountReceipt) return

    try {
      const response = await axios.get(`${config.apiHost}/app/userClaim/claimableAmount`, {
        params: {
          requestAmount: formValues?.amountReceipt,
          claimId: hepatitisId
        },
        headers: {
          'X-Auth-Token': `${getToken()}`
        }
      })

      setIsClaimCheck(true)
      setClaimAmountCheck(response.data.actualAmount)
      if (response.data.actualAmount === 0 || formValues?.amountReceipt > response.data.actualAmount) {
        setMessageClaimCheck(response.data.messageTh)
        modalAction.show()
      }
    } catch (error: any) {
      console.error(error)
      const message = error.response?.data?.messageTh || error.messageTh
      setErrorClaimMessage(message || 'วงเงินของคุณไม่เพียงพอสำหรับการเบิก')
      modalActionError.show()
    }
  }, [formValues?.amountReceipt, hepatitisId, modalAction, modalActionError])

  const validateImage = useCallback((name: 'receiptFile' | 'optionalFileUrl' | 'birthCertificate' | 'otherDocument', isRequired) => {
    if (isPreview === false && (!formValues[name]) && isRequired) {
      return [required]
    } else {
      return undefined
    }
  }, [formValues, isPreview])

  const validateClaimAmount = useCallback(
    (value) => {
      if (hepatitisItem?.claimPrice && value > hepatitisItem?.claimPrice) {
        return 'eClaim.claimPriceError'
      }
    },
    [hepatitisItem?.claimPrice],
  )

  const isEnoughCoin = useCallback(
    (value) => {
      if (value > userCoin) {
        return 'eClaim.coinError'
      }
    },
    [userCoin])

  const isNotZero = useCallback(
    (value) => {
      if (value === '0') {
        return 'error.required'
      }
    }
    , [])

  const nameRelative = useCallback(
    (relativeId: number | string) => {
      const data = relativesOptions?.map((relativesOption) => {
        const { value, label } = relativesOption
        if (relativeId.toString() === value) {
          return label
        }
      })
      return data?.length === 0 ? 'ตัวเอง' : data
    },

    [relativesOptions],
  )

  const fullNameSummary = useMemo(() => {
    if (!hepatitisFormValue?.relativeTypeId) return fullname

    return hepatitisFormValue?.relativeTypeId === '0' ? fullname : nameRelative(hepatitisFormValue?.relativeTypeId)
  }, [hepatitisFormValue?.relativeTypeId, fullname, nameRelative])

  const fileTypeFormat = useCallback((name: FileType): 'receiptFile' | 'optionalFileUrl' | 'birthCertificate' | 'otherDocument' => {
    switch (name) {
      case FileType.ReceiptFile:
        return 'receiptFile'
      case FileType.OptionalFileUrl:
        return 'optionalFileUrl'
      case FileType.BirthCertificate:
        return 'birthCertificate'
      case FileType.OtherDocument:
        return 'otherDocument'
      default:
        return 'otherDocument'
    }
  }, [])

  const disbleField = allpayStatus ? true : false

  const disabledSubmit = useMemo(() => {
    return invalid || !isClaimCheck
  }, [invalid, isClaimCheck])

  if (editable && !formValues) return null

  return (
    <>
      <Modal
        visible={visibleError}
        onCancel={() => {
          modalActionError.hide()
        }}
        onCancelText="ตกลง"
      >
        <div style={{ margin: '30px' }}>
          <TextModal size={24} type="Bold">
            {errorMessage}
          </TextModal>
          <TextModal>กรุณาตรวจสอบอีกครั้ง</TextModal>
          {errorClaimMessage && (<TextModal color="red">{errorClaimMessage}</TextModal>)}
        </div>
      </Modal>
      <Modal
        visible={visible}
        onCancel={() => {
          modalAction.hide()
        }}
        onCancelText="ตกลง"
      >
        <div style={{ margin: '30px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', rowGap: 8 }}>
          <Image imageName='iconAlertPrivacy' width={72} />
          <TextModal>{messageClaimCheck}</TextModal>
        </div>
      </Modal>
      <ClaimFormContainer>
        <Text size={24} type="Bold">
          {editable ? 'กรอกรายละเอียดการเบิกสวัสดิการ' : 'ตรวจสอบรายละเอียด '}
        </Text>
        <InputContainer>
          {editable && (
            <FlexCol>
              <InputLabel size={18}>ชื่อ - นามสกุล ผู้ขอเบิก</InputLabel>
              <Text type="Bold" size={16}>{fullname}</Text>
            </FlexCol>
          )}
          {editable && (
            <FlexCol>
              <InputLabel size={18}>
                {t('eClaim.detail.form.claimFor')}{' '}
              </InputLabel>
              <RelativeField>
                <SelectField
                  name="relativeTypeId"
                  placeholder={t('eClaim.detail.form.claimFor')}
                  validate={[required]}
                  options={relativesOptions || []}
                  disabled={disbleField}
                  style={{ width: '100%' }}
                />
                {/* <CreateRelativeButton onClick={setVisibleCreate.show}>{t('family.addTitle')}</CreateRelativeButton> */}
              </RelativeField>
            </FlexCol>
          )}
          {isHistory && (
            <>
              <FlexCol>
                <InputLabel size={18}>{t('eClaim.detail.form.claimFor')}</InputLabel>
                <Text size={16} type='Bold'>{hepatitisItem?.relativeId ? nameRelative(hepatitisItem?.relativeId) : fullname}</Text>
              </FlexCol>
            </>
          )}
          {isPreview && (
            <FlexCol>
              <InputLabel size={18}>{t('eClaim.detail.form.claimFor')}</InputLabel>
              <Text size={16} type='Bold'>{fullNameSummary}</Text>
            </FlexCol>
          )}
        </InputContainer>
        <InputContainer>
          <FlexCol>
            {editable && (
              <InputField
                name="receiptNo"
                label={t('eClaim.detail.form.receiptNo')}
                placeholder={t('eClaim.detail.form.inputReceiptNo')}
                validate={[required]}
                disabled={disbleField}
                labelSize={18}
              />
            )}
            {isPreview && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.receiptNo')}</InputLabel>
                <Text type="Bold">{hepatitisFormValue?.receiptNo}</Text>
              </>
            )}
            {isHistory && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.receiptNo')}</InputLabel>
                <Text type="Bold">{hepatitisItem?.receiptNo}</Text>
              </>
            )}
          </FlexCol>
          <FlexCol>
            {editable && (
              <DatePickerField
                name="receiptDate"
                label="วันที่ในใบเสร็จ"
                validate={[required, requiredDate]}
                disabled={disbleField}
                labelSize={18}
                maxDate={dayjs().endOf('day')}
                minDate={dayjs('07/01/2023')}

              />
            )}
            {isPreview && (
              <>
                <InputLabel size={18}>วันที่ในใบเสร็จ</InputLabel>
                <Text type="Bold">{dayjs(hepatitisFormValue?.receiptDate).format('DD/MM/YYYY')}</Text>
              </>
            )}
            {isHistory && (
              <>
                <InputLabel size={18}>วันที่ในใบเสร็จ</InputLabel>
                <Text type="Bold">{dayjs(hepatitisItem?.slipDate).format('DD/MM/YYYY')}</Text>
              </>
            )}
          </FlexCol>
        </InputContainer>
        <InputContainer>
          <FlexCol>
            {editable && (
              <InputField
                name="amountReceipt"
                label={t('eClaim.detail.form.amountReceipt')}
                placeholder={t('eClaim.detail.form.inputAmount')}
                validate={[required, validateClaimAmount, isNotZero]}
                inputType="number"
                disabled={disbleField}
                labelSize={18}
              />
            )}
            {isPreview && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.amountReceipt')}</InputLabel>
                <Text type="Bold" size={16}>
                  {hepatitisFormValue?.amountReceipt ? numberWithCommas(Number(hepatitisFormValue?.amountReceipt)) : 0}
                </Text>
              </>
            )}
            {isHistory && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.amountReceipt')}</InputLabel>
                <Text type="Bold" size={16}>
                  {hepatitisItem?.userClaimAmount ? numberWithCommas(Number(hepatitisItem?.userClaimAmount)) : 0}
                </Text>
              </>
            )}
          </FlexCol>
          {editable && (
            <FlexCol style={{ marginBottom: 0 }}>
              <InputLabel size={18}>{' '}</InputLabel>
              <OutlineButton onClick={onCheckCoin}>ตรวจสอบสิทธิ</OutlineButton>
            </FlexCol>
          )}
          <FlexCol>
            {isClaimCheck && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.claimAmount')}</InputLabel>
                <Text type="Bold" size={16}>{numberWithCommas(claimAmountCheck)}</Text>
              </>
            )}
            {isPreview && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.claimAmount')}</InputLabel>
                <Text type="Bold" size={16}>
                  {hepatitisFormValue?.amountClaim ? numberWithCommas(Number(hepatitisFormValue?.amountClaim)) : 0}
                </Text>
              </>
            )}
            {isHistory && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.claimAmount')}</InputLabel>
                <Text type="Bold" size={16}>
                  {hepatitisItem?.userClaimAmountApprove ? numberWithCommas(Number(hepatitisItem?.userClaimAmountApprove)) : 0}
                </Text>
              </>
            )}
          </FlexCol>
        </InputContainer>
        {/* <InputContainer>
          <FlexCol>
            {editable && (
              <InputField
                name="remark"
                label={t('eClaim.detail.form.remark')}
                placeholder={t('eClaim.detail.form.inputRemark')}
                disabled={disbleField}
                labelSize={18}
              />
            )}
            {isPreview && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.remark')}</InputLabel>
                <Text type="Bold">{hepatitisFormValue?.remark}</Text>
              </>
            )}
            {isHistory && (
              <>
                <InputLabel size={18}>{t('eClaim.detail.form.remark')}</InputLabel>
                <Text type="Bold">{hepatitisItem?.remark}</Text>
              </>
            )}
          </FlexCol>
        </InputContainer> */}
        <Text size={24} type="Bold">
          {t('eClaim.detail.form.attachDocuments')}
        </Text>
        <FileUploadContainer>
          {!isHistory && hepatitisItem && hepatitisItem?.claimDocumentTypes?.map((item, index) => {
            return (
              <UploadfileField
                key={index}
                name={fileTypeFormat(item.documentType.name)}
                icon={'receiptIcon'}
                title={`${index + 1}. ${item.documentType.name}`}
                desc={item.documentType.description || ''}
                // value={item.documentType.name === FileType.ReceiptFile ? hepatitisFormValue?.receiptFile : hepatitisFormValue?.optionalFileUrl}
                isDelete={isPreview}
                validate={validateImage(fileTypeFormat(item.documentType.name), item.isRequired)}
                maximumFileSize={3}
              // disabled={disbleField}
              />
            )
          })
          }
          {isHistory && hepatitisItem && hepatitisItem?.documentTypes?.map((item, index) => {
            return (
              <UploadfileField
                key={index}
                name={fileTypeFormat(item.name)}
                icon={'receiptIcon'}
                title={`${index + 1}. ${item.name}`}
                desc={item.description || ''}
                // value={hepatitisFormValue?.userClaimDocumentList[index]?.documentPath}
                isDelete={isHistory}
                // validate={validateImage(item.documentType.name === FileType.ReceiptFile ? 'receiptFile' : 'optionalFileUrl', item.isRequired)}
                maximumFileSize={3}
                disabled={true}
              />
            )
          })
          }
        </FileUploadContainer>
        {editable && (
          <ButtonWrapper>
            <SubmitButton onClick={handleSubmit(onSubmit)} disabled={disabledSubmit}>
              {t('eClaim.detail.form.next')}
            </SubmitButton>
          </ButtonWrapper>
        )}
        {isPreview && (
          <ButtonWrapper>
            <SubmitButton onClick={onSubmitApplication} disabled={isSubmitting || isUploading || isLoading}>
              {t('eClaim.detail.form.submit')}
            </SubmitButton>
          </ButtonWrapper>
        )}
      </ClaimFormContainer>
    </>
  )
}

export default reduxForm<HepatitisFormParams, HepatitisParam, string>({
  form: ECLAIM_FORM_NAME,
})(EClaimForm)
